import { CaptionsOptions } from 'features/application/types';
import {
  fontSizeChanged,
  spokenLanguageApplyToAllChanged,
  spokenLanguageChanged,
} from 'features/transcripts/slices/captions/captionsSlice';
import { selectFeatureFlag } from 'features/feature-set/featuresSlice';
import { call, put, select } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';
import { PermissionTypes } from 'features/permissions/types';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';

export function* onConfigureCaptionsCommandSaga(options: Partial<CaptionsOptions>) {
  const controlEnabled: boolean = yield select(selectFeatureFlag, 'captions');
  const applySpokenLanguageToAll =
    typeof options.applySpokenLanguageToAll === 'boolean'
      ? options.applySpokenLanguageToAll
      : undefined;

  if (!controlEnabled) {
    yield call(
      eventBus.notAllowedError,
      'This feature is disabled. You’ll need to edit this room’s properties to enable it.',
      'captions'
    );

    return;
  }

  const canTranscribeSession: boolean = yield call(
    hasPermissionsSaga,
    PermissionTypes.transcribeSession
  );

  if (applySpokenLanguageToAll && !canTranscribeSession) {
    yield call(
      eventBus.forbiddenActionError,
      'Forbidden action. This participant is not allowed to apply the spoken language to all participants.',
      'captions'
    );

    return;
  }

  if (options.fontSize) {
    const fontSizePx = { small: 16, medium: 24, large: 32 }[options.fontSize];

    yield put(fontSizeChanged(fontSizePx));
  }

  if (options.spokenLanguage) {
    yield put(
      spokenLanguageChanged({ code: options.spokenLanguage, applyToAll: applySpokenLanguageToAll })
    );
  }

  if (applySpokenLanguageToAll !== undefined) {
    yield put(spokenLanguageApplyToAllChanged(applySpokenLanguageToAll));
  }
}
